import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {AbstractControl} from '@angular/forms';

@Component({
  selector: 'error-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.css'],
})
export class ErrorMessageComponent {
  @Input() control: AbstractControl | null = null;
  @Input() customMessages: Record<string, string> = {};
  /** When true, error flows below preceding content (e.g. hint) instead of absolute positioning. */
  @Input() stacked = false;
  @Input() submitted = false;

  private readonly defaultMessages: Record<string, string> = {
    required: 'Campo obrigatório',
    email: 'E-mail inválido',
    invalidDateFormat: 'Formato inválido (dd/mm/aaaa)',
    invalidDate: 'Data inválida',
    futureDate: 'A data não pode ser no futuro',
    tooOld: 'A data não pode ter mais de 150 anos',
    endBeforeStart: 'Data final não pode ser anterior à inicial',
    fullName: 'O nome deve conter pelo menos duas palavras diferentes.',
  };

  /** First validation error key only (stable order from `errors` object keys). */
  get firstErrorKey(): string | null {
    if (!this.control || !this.control.errors) {
      return null;
    }
    if (!this.submitted && !this.control.touched && !this.control.dirty) {
      return null;
    }
    const keys = Object.keys(this.control.errors);
    return keys.length ? keys[0] : null;
  }

  getMessage(errorKey: string): string {
    const value = this.control?.errors?.[errorKey];
    if (typeof value === 'string') {
      return value;
    }
    return (
      this.customMessages[errorKey] ??
      this.defaultMessages[errorKey] ??
      'Campo inválido'
    );
  }
}
